import { NodeViewWrapper, type NodeViewProps } from "@tiptap/react";
import { VARIABLE_MENTION_PILL_MARGIN_Y } from "../variable-mention/variable-mention.constants";
import { TemplateChip } from "./template-chip";
import { templateFromNode } from "./template-mention.utilities";

/**
 * React node view for a `templateMention` node: the composer's `TemplateChip` in an inline `<span>`, so the chip sits
 * in the paragraph's text flow with the same vertical margin as a variable pill.
 * @param props.node     The ProseMirror node, whose attributes hold the template.
 * @param props.selected Whether the node is inside the current selection.
 * @returns {JSX.Element} The node view.
 */
export const TemplateMentionView = ({ node, selected }: NodeViewProps) => (
    <NodeViewWrapper as="span">
        <TemplateChip
            command={templateFromNode(node).command}
            selected={selected}
            my={VARIABLE_MENTION_PILL_MARGIN_Y}
        />
    </NodeViewWrapper>
);
